// 3rd
import { Model } from '@vuex-orm/core';
import Brand from './Brand';

export default class Achievement extends Model {
    static entity = 'achievements';

    static fields() {
        return {
            id: this.attr(null),
            achievements: this.attr(null),
            level_system: this.attr(null),
            actual_rank: this.attr(null),
            masterpoints: this.attr(null),
            masterpoints_target: this.attr(100),
            next_rank: this.attr(null),
            brand_id: this.attr(null),
            protection: this.attr(null),
            ihk_certificate: this.boolean(false),
            show_extended_achievements: this.boolean(false),
            brand: this.belongsTo(Brand, 'brand_id'),
        }
    }

    // getters
    static getAll() {
        return Achievement.query().withAll().all();
    }

    static getHighestRank() {
        let highestRankScore = 0;
        let rank = null;
        Achievement.query().withAll().all().forEach((achievement) => {
            if (highestRankScore < achievement.actual_rank.point_value) {
                highestRankScore = achievement.actual_rank.point_value;
                rank = achievement.actual_rank;
            }
        });
        return rank;
    }

}
